import { useSetNewDataState, useSetReserveSuccessState } from "@/shared/client";
import { API_RESERVE, type ReserveInfoResponse } from "@/shared/server";
import { useMutation } from "@tanstack/react-query";

export const useHandleData = () => {
    const setNewData = useSetNewDataState();
    const setIsReserveStatus = useSetReserveSuccessState();

    const mutation = useMutation({
        mutationFn: API_RESERVE.getReserveRoomInfo<ReserveInfoResponse>,
        onMutate: () => {
            setIsReserveStatus(false);
        },
        onSuccess: (data) => {
            setNewData(data);
            setIsReserveStatus(true);
        },
    });

    return mutation;
};
